module.exports = __webpack_public_path__ + "media/videos/video-bike.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/videos/video-bike.mp4
// module id = 743
// module chunks = 0